import React from 'react';
import Navbar from '../Navbar';
import HeroSection from '../HeroSection';
import Footer from '../Footer';

const Home = () => {
  return (
    <div className="home-page">
      <Navbar />
      <HeroSection />
      <Footer />
    </div>
  );
};

export default Home; 